import { Injectable, ɵɵresolveBody } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { baseURL } from './baseurl';
import { ProcessHTTPMsgService } from './process-httpmsg.service';
import { Router } from '@angular/router';
import jwtDecode, * as jwt_decode from 'jwt-decode';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  tokenKey = 'JWT';
  isAuthenticated: Boolean = false;
  username: string;
  authToken: string = undefined;
  refreshToken: string = undefined;
  expiresIn: number;
  client_secret = "ur8SVkSUoUS6oDxRWW3vQmCgcMyT0wLoCUTwM5fXfz3nOnYac9LiJMXQoICgTQTzFjEdXk44a6yQliXK9TZJhpmvrvxLdKByMTjmmwnm85vpwpJbiE8mmTBLHUdVl9di";
  client_id = "TfjYlD4nywzRf56HwDhZbepBsJ9EDFB21izDrf4J";

   constructor(private http: HttpClient,
     private processHTTPMsgService: ProcessHTTPMsgService) {
   }
   /*checkJWTtoken() {
    this.http.get<any>(baseURL + 'users/checkJWTtoken')
    .subscribe(res => {
      console.log('JWT Token Valid: ', res);
      this.sendUsername(res.user.username);
    },
    err => {
      console.log('JWT Token invalid: ', err);
      this.destroyUserCredentials();
    });
  }*/

  sendUsername(name: string) {
    this.username = name;
  }

  clearUsername() {
    this.username = undefined;
  }

  loadUserCredentials() {
    const credentials = JSON.parse(localStorage.getItem(this.tokenKey));
    //console.log('loadUserCredentials ', credentials);
    if (credentials && credentials.username !== undefined) {
      this.useCredentials(credentials);
      /*if (this.authToken) {
       this.checkJWTtoken();
      }*/
    }
  }

  storeUserCredentials(credentials: any) {
    //console.log('storeUserCredentials ', credentials);
    localStorage.setItem(this.tokenKey, JSON.stringify(credentials));
    this.useCredentials(credentials);
  }

  useCredentials(credentials: any) {
    this.isAuthenticated = true;
    this.sendUsername(credentials.username);
    this.authToken = credentials.token;
    this.expiresIn = credentials.expiresIn;
    this.refreshToken = credentials.refresh_token;
  }

  destroyUserCredentials() {
    console.log("destroy");
    this.authToken = undefined;
    this.clearUsername();
    this.isAuthenticated = false;
    localStorage.removeItem(this.tokenKey);
  }

  getTokenExpirationDate(time): Date {

    if (time === undefined) return null;
    const date = new Date();
    date.setUTCSeconds(time);
    return date;
  }

  isTokenExpired(): boolean {
    this.loadUserCredentials();
    const date = this.expiresIn;
    //console.log(this.expiresIn);
    if(date === undefined) return true;
    //console.log(date.valueOf());
    //console.log(new Date().toISOString().valueOf());
    //console.log(date.toString() < new Date().toISOString());
    if (date.toString() < new Date().toISOString()){
      return true;
    }else{
      return false;
    }
  }

  postUser(user:any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json'});                                                                             
    const formdata: FormData = new FormData();
    formdata.append('client_id',this.client_id);
    formdata.append('client_secret',this.client_secret);
    formdata.append('username',user.username);
    formdata.append('password',user.password);
    formdata.append('first_name',user.first_name);
    formdata.append('last_name',user.last_name);
    if(user.profile_picture){formdata.append('profile_picture',user.profile_picture);}
    formdata.append('email',user.email);
    formdata.append('grant_type',"password");
    return this.http.post<any>(baseURL + 'api/users/',
      formdata)
       .pipe( map(res => {
        if(res){
           let loguser = {"username": user.username, "password": user.password};
           /*this.logIn(loguser).subscribe(
             res=>{
               if(res){
                console.log("Logged In with new user");
                return true;
               }
            }, 
             error=>console.log(error)
             );*/
             return loguser;
          }
        }),
        catchError(error => this.processHTTPMsgService.handleError(error)));

  }
  updateUser(user:any): Observable<any> {
    this.loadUserCredentials();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ this.authToken});                                                                     
    const formdata: FormData = new FormData();
    if(user.username) formdata.append('username',user.username);
    if(user.first_name) formdata.append('first_name',user.first_name);
    if(user.last_name) formdata.append('last_name',user.last_name);
    if(user.profile_picture){formdata.append('profile_picture',user.profile_picture);}
    if(user.email)formdata.append('email',user.email);
    return this.http.patch<any>(baseURL + 'api/users/me/',
      formdata,{headers})
          .pipe( map(res => {
            //console.log(res.access_token);
            this.loadUserCredentials();
            this.storeUserCredentials({username: user.username, token: this.authToken, expiresIn: this.expiresIn, refresh_token: this.refreshToken});
            this.username = user.username;
            return true;
        }),
         catchError(error => this.processHTTPMsgService.handleError(error)));
  }

   logIn(user: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json'});                                                                             
    const formdata: FormData = new FormData();
    formdata.append('client_id',this.client_id);
    formdata.append('client_secret',this.client_secret);
    formdata.append('username',user.username);
    formdata.append('password',user.password);
    formdata.append('grant_type',"password");
    //console.log(user);
     return this.http.post<any>(baseURL + 'auth/token/',
      formdata)
       .pipe( map(res => {
           //console.log(res.access_token);
           this.storeUserCredentials({username: user.username, token: res.access_token, expiresIn: this.getTokenExpirationDate(res.expires_in), refresh_token: res.refresh_token});
           this.username = user.username;
           return true;
       }),
        catchError(error => this.processHTTPMsgService.handleError(error)));
   }

   refreshlogIn(): Observable<any> {
    // console.log("REFRESH LOGIN");
     this.loadUserCredentials();
    // console.log(this.refreshToken);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json'});                                                                             
    const formdata: FormData = new FormData();
    formdata.append('client_id',this.client_id);
    formdata.append('client_secret',this.client_secret);
    formdata.append('refresh_token', this.refreshToken);
    formdata.append('grant_type',"refresh_token");
    //console.log(user);
    //this.destroyUserCredentials();
     return this.http.post<any>(baseURL + 'auth/token/',
      formdata)
       .pipe( map(res => {
           //console.log("Check");
           this.storeUserCredentials({username: this.username, token: res.access_token, expiresIn: this.getTokenExpirationDate(res.expires_in), refresh_token: res.refresh_token});
           return true;
       }),
        catchError(error => this.processHTTPMsgService.handleError(error)));
   }

   changePassword(password){
    this.loadUserCredentials();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ this.authToken});                                                                     
    const formdata: FormData = new FormData();
    formdata.append('old_password',password.old);
    formdata.append('new_password',password.new);
    return this.http.patch<any>(baseURL + 'api/users/password-change/',
      formdata,{headers})
          .pipe( map(res => {
            console.log("Password Changed Successfully");
            return true;
        }),
         catchError(error => this.processHTTPMsgService.handleError(error)));
   }

   logOut() {
    this.destroyUserCredentials();
  }

  isLoggedIn(): Boolean {
    return this.isAuthenticated;
  }

  getUsername(): string {
    return this.username;
  }


  getToken(): string {
    return this.authToken;
  }

  getUserdetail():Observable<any>{
    this.loadUserCredentials();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ this.authToken}); 
    //console.log(baseURL + 'api/users/me/');
    return this.http.get<any>(baseURL + 'api/users/me/', {headers});    
  }

  getUserdetailByUsername(username):Observable<any>{
    //console.log(baseURL + 'api/users/'+username+'/');
    return this.http.get<any>(baseURL + 'api/users/'+username+'/');    
  }
}
